// utils/isImageOrVideo.js
export function isVideoUrl(url) {
   return url?.match(/\.(mp4|mov|avi|wmv|flv|webm)$/i)
}

export function isImageUrl(url) {
   return url?.match(/\.(jpeg|jpg|gif|png|webp|bmp|svg)$/i)
}
